export default __webpack_public_path__ + "static/media/1272.d754590c.png";